import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { CalendarioFormComponent } from 'src/app/pages/calendario-form/calendario-form.component';

@Injectable()
export class CalendarioGuard
  implements CanDeactivate<CalendarioFormComponent> {
  canDeactivate(
    component: CalendarioFormComponent
  ): Observable<boolean> | boolean {
    if (!component.visualizar) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    }
    else { return true; }
  }
}
